import type { ReactNode } from "react";

/** A labelled row of toggle buttons, one pressed. */
export function Segmented<T extends string>({
  label,
  options,
  value,
  onChange,
  render,
}: {
  label: string;
  options: readonly T[];
  value: T;
  onChange: (v: T) => void;
  render: (v: T) => ReactNode;
}) {
  return (
    <fieldset className="form-field">
      <legend>{label}</legend>
      <div className="segmented" role="group">
        {options.map((o) => (
          <button key={o} type="button" className="seg" aria-pressed={value === o} onClick={() => onChange(o)}>
            {render(o)}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
